import countries from 'i18n-iso-countries'

countries.registerLocale(require('i18n-iso-countries/langs/en.json'))

/**
 * Accepts a 2-3-digit country code and converts it to a 2-digit country code using i18n-iso-countries.
 *
 * @param countryCode Case insensitive 2- or 3-digit country code
 */
export const getCountryName = (countryCode: string): string | null | undefined => {
  if (!countryCode || !countries.isValid(countryCode)) return null
  return countries.getName(countryCode, 'en', { select: 'official' })
}
